module.exports = __webpack_public_path__ + "images/mdj/members/resume/resume_end_screen/flow-image05-7a18e5cd116612330e0109d3ab1cc5e4.png";